module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst showToolTipByType = {\nnew: true,\noutDated: true,\npositive: true,\n}\n%><div><%\n%><%- include('./charts/doughnut', { model: { stats: model.stats }}) %><%\n%><ul><%\nfor(const type in model.stats || {}){\n%><li class=\"<%= type %>\"><%\nif(showToolTipByType[type]){\n%><div class=\"info\"><%- include('../../../base/tooltip/tooltip', { config: {\norientation: 'NE-SW',\n}, model: {\n\"title\": \"Info\",\nmessage: storage.__(`advertisements.stats.typeInfos.${type}`),\n}}); %></div><%\n}\n%><div><%\n%><i class=\"fi fi-advertisements\"></i><%= storage.__(`advertisements.stats.types.${type}`) %><%\n%></div><%\n%><div class=\"dots\">&nbsp;</div><%\n%><div class=\"amount\"><%= model.stats[type] || 0 %></div><%\n%></li><%\n}\n%></ul><%\n%></div>"
  , __filename = "components/templates/crew/advertisements/stats.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const showToolTipByType = {
new: true,
outDated: true,
positive: true,
}

    ; __line = 7
    ; __append("<div>")
    ; 

    ; __line = 8
    ; __append( include('./charts/doughnut', { model: { stats: model.stats }}) )
    ; 

    ; __line = 9
    ; __append("<ul>")
    ; 
for(const type in model.stats || {}){

    ; __line = 11
    ; __append("<li class=\"")
    ; __append(escapeFn( type ))
    ; __append("\">")
    ; 
if(showToolTipByType[type]){

    ; __line = 13
    ; __append("<div class=\"info\">")
    ; __append( include('../../../base/tooltip/tooltip', { config: {
orientation: 'NE-SW',
}, model: {
"title": "Info",
message: storage.__(`advertisements.stats.typeInfos.${type}`),
}}) )
    ; __line = 18
    ; __append("</div>")
    ; 
}

    ; __line = 20
    ; __append("<div>")
    ; 

    ; __line = 21
    ; __append("<i class=\"fi fi-advertisements\"></i>")
    ; __append(escapeFn( storage.__(`advertisements.stats.types.${type}`) ))
    ; 

    ; __line = 22
    ; __append("</div>")
    ; 

    ; __line = 23
    ; __append("<div class=\"dots\">&nbsp;</div>")
    ; 

    ; __line = 24
    ; __append("<div class=\"amount\">")
    ; __append(escapeFn( model.stats[type] || 0 ))
    ; __append("</div>")
    ; 

    ; __line = 25
    ; __append("</li>")
    ; 
}

    ; __line = 27
    ; __append("</ul>")
    ; 

    ; __line = 28
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/crew/advertisements/stats.ejs

}